<template>
    <div class="my-icon-input" :class="{isError:isError}">
      <el-input :type="inputType" :placeholder="placeholder" :autofocus="false"  @blur="onBlur" v-model="input1" clearable tabindex="-1">
        <template slot="prepend">
          <div class="prepend" style=" display: flex;align-items: center;">
            <img :src="leftIcon" alt="">
            <span v-if="isLogin" style="margin-left: 5px; font-size: 13px;width: 50px;text-align: center;" >手机号码</span>
            <div class="divider"></div>
          </div>
        </template>
      </el-input>
      <div class="my-icon-input-error" v-show="isError" v-text="errorText"></div>
    </div>
  </template>
  <script>
  export default {
    components: {}, 
    model: {
      prop: 'value'
    },
    props: {
      value: {type: String, default: null},
      leftIcon: {
        type: String,
        default: require('@/assets/icons/user.png')
      },
      isLogin: {
        type: Boolean,
        default: false
      },
      rightIcon: {
        type: String,
        default: ''
      },
      require: {
        type: Boolean,
        default: false
      },
      inputType:{
        type: String,
        default: 'text'
      },
      errorTip: {
        type: String,
        default: '请输入'
      },
      placeholder: {
        type: String,
        default: '请输入内容'
      },
  
    },
    computed: {},
  
    data() {
      return {input1: this.value, isError: false, errorText: this.errorTip};
    },
    mounted() {
  
    },
  
    watch: {
      input1(newval) {
        console.log("---",newval);
        this.isError = this.isEmpty(newval)
        this.$emit('input',newval)
      },
      value(newval){
        this.input1=newval;
      }
    },
    methods: {
      onBlur() {
        console.log("22");
        if (this.require && (this.input1 == '' || this.input1 == undefined || this.input1 == null)) {
          this.isError = true;
        }
      },
      async valid(cbk) {
        console.log("----va");
        await cbk(this.input1).then(j => {
          this.isError = false;
        }).catch(err => {
          this.isError = true;
          this.errorText = err||this.errorTip;
        })
        return this.isError;
      }
    }
  }
  </script>
  <style lang="scss" scoped>
  .my-icon-input {
    width: 100%;
    height: 100%;
    border-radius: 2px;
    border: 1px solid #00000026;
    font-size: 16px;
    *{
      font-size: inherit;
    }
    &.isError {
      border: 1px solid #F53F3F;
    }
  
    position: relative;
    box-sizing: border-box;
  
    & /deep/ {
      .el-input {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        display: flex;
      }
  
      .el-input-group__prepend {
        width: auto;
        background-color: transparent;
        border: unset;
        padding: 13px 0px;
  
        img {
          margin-left: 16px;
          width:16px;
          height:16px;
        }
  
        .divider {
          display: inline-block;
          width: 1px;
          height: 12px;
          margin-left: 16px;
          background: rgba(0, 0, 0, 0.15);
        }
      }
  
      .el-input__inner {
        width: 10px;
        flex: 1;
        height: 100%;
        border: unset;
      }
  
      .my-icon-input-error {
        position: absolute;
        left: 0;
        bottom: -17px;
        //width: 60px;
        height: 17px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #F53F3F;
        line-height: 17px;
        text-align: left;
        font-style: normal;
      }
    }
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/MyPhone.vue